import { render, staticRenderFns } from "./container-profile.vue?vue&type=template&id=0bf7eee1&"
import script from "./container-profile.vue?vue&type=script&lang=js&"
export * from "./container-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports